import { ExportFormats, ExportPayload } from '@qualio/export-components';
import { EventTemplateDetailsResponse } from '../../../../../types/eventTemplateDetails';

type ExportOptions = {
  coverPageEnabled: boolean;
};

export const buildExportEventTemplatesPayload = (
  eventTemplate: EventTemplateDetailsResponse,
  companyId: number,
  currentUserName: string,
  queryParams: ExportOptions,
): ExportPayload => {
  const { coverPageEnabled } = queryParams;
  const { id, lineage_id } = eventTemplate;
  const event_template_id = String(id);
  const params = new URLSearchParams({
    generated_by: currentUserName,
    include_cover_page: String(coverPageEnabled),
    ...(lineage_id && { event_template_lineage_id: lineage_id }),
    ...(event_template_id && { event_template_id }),
  });

  return {
    exports: [
      {
        format: ExportFormats.bulk,
        data: [
          {
            resource_description: `Event template ${eventTemplate.prefix} ${eventTemplate.name}`.slice(0, 100),
            export_payload: `${
              process.env.REACT_APP_MEDTECH_BACKEND_API_URL
            }/quality-events/${companyId}/workflows/export-payload?${params.toString()}`,
          },
        ],
      },
    ],
    metadata: {
      domain: 'quality-event-template',
      resource_name: `${eventTemplate.prefix} ${eventTemplate.name} export`.slice(0, 100),
      send_notification: false,
    },
  };
};
